<div class="flex h-16 w-full items-center justify-between bg-white p-4">
	<div>
		<p-button
			icon="pi pi-bars"
			[text]="true"
			[rounded]="true"
			severity="secondary"
			(click)="emitMenu()"
			(keydown.enter)="emitMenu()"
			(keydown.space)="emitMenu(); $event.preventDefault()"
		></p-button>
	</div>
	<div class="flex flex-col items-center justify-center">
		<svg-icon src="./assets/images/logo-small.svg" name="header-logo" class="block h-7 [&_svg]:h-full"></svg-icon>
	</div>
	<div></div>
</div>
